import { useMutation } from '@tanstack/react-query';
import { POST, POST_CHANGE_DATE_BOOKING } from '../../../../../../services';
import { openAlert } from '../../../../../../components/alert/hooks';

export const useChangeDateBooking = () =>
  useMutation({
    mutationFn: async (data) => {
      const response = await POST(POST_CHANGE_DATE_BOOKING(), data);
      return response;
    },
    onSuccess: (data) => {
      openAlert({ model: 'message', type: 'success', message: data?.message });
      window.location.reload();
    },
    onError: (error) => {
      openAlert({ model: 'message', type: 'error', message: error?.message });
      window.location.reload();
    },
  });
